import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  parameterService() {
    return this.http.get(environment.url + '/MG/Parameter',
      { headers: this.headers.set('Authorization', sessionStorage.getItem('t_admin')) }).pipe(retry(1), catchError(this.errorHandl));
  }

  updateParams(element) {
    return this.http.put<any>(environment.url + '/MG/Parameter', element, {
      headers: this.headers.set('Authorization',
        sessionStorage.getItem('t_admin'))
    })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
